import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { Toaster } from "sonner";

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--primary-text)]">
      <Navigation />
      <main data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#f8f5f0",
            borderRadius: "0",
            fontFamily: "Tenor Sans, sans-serif",
            letterSpacing: "0.08em",
            fontSize: "13px",
          },
        }}
      />
    </div>
  );
};

export default Layout;
